/**
 * Application configuration
 */

import { resolveApiBaseUrl } from './config.api';

export const config = {
  /**
   * API configuration
   */
  api: {
    /**
     * Base URL for API requests
     * The env value may be provided with or without the '/api' suffix.
     * The resolver keeps the final URL normalized in one place.
     */
    baseURL: resolveApiBaseUrl(import.meta.env.VITE_API_URL),
  },
  
  /**
   * Authentication configuration
   */
  auth: {
    /**
     * Local storage keys
     */
    storageKeys: {
      token: 'suaFrotaToken',
      user: 'suaFrotaUser',
    },
    
    /**
     * Token expiration time in milliseconds
     * Default: 1 hour
     */
    tokenExpiration: 60 * 60 * 1000,
    roles: {
      admin: 'admin',
      user: 'user',
      client: 'client',
    },
  },
  app: {
    name: 'SuaFrota',
    version: '1.0.0',
  },
} as const;

export type Config = typeof config;
